import "./css/app.scss";
import "./ts/neto.js";


import lazyLoad from "./ts/lazyLoad";
import loadSprite from "./ts/loadSprite";
import { addEvent , appHeight } from "./ts/utils";
import sliders from "./ts/slider";
import accents from "./ts/accentChange";
import descMenu from "./ts/descMenu";
import mobMenu from "./ts/mobMenu";
import advertWrap from "./ts/advertWrap";
import readMore from "./ts/readmore";
import accordian from "./ts/accordian";
import tabs from "./ts/tabs";
import counter from "./ts/counter";

addEvent();
appHeight();
loadSprite.init();
lazyLoad.init();
sliders.init();
accents.init();
descMenu.init();
mobMenu.init();
advertWrap.init();
readMore.init();
accordian.init();
tabs.init();
counter.init();